<template>
  <LayoutPage :loading="loading" :title="incidentTitle">
    <template v-if="!needsSurvey" #actions>
      <ButtonPrint :icon="false" color="grey darken-2" />
    </template>

    <v-row>
      <!-- Survey form: shown when survey is needed and no tasks exist (tasks use DialogViewTask survey tab) -->
      <v-col v-if="needsSurvey && !surveyed && !hasTasks" md="8">
        <FormIncidentSurvey />
      </v-col>
      <v-col cols="12" class="mx-auto print-full-width">
        <CardIncidentInfo
          :single-column="needsSurvey && !surveyed && !hasTasks"
        />
      </v-col>
      <v-col cols="12">
        <div v-if="showTaskManagement" class="d-flex justify-end mb-2">
          <AddNewTask :default-value="defaultValue" />
        </div>
        <CardIncidentTasks />
      </v-col>
      <v-col v-if="surveyed" cols="12" class="print-full-width">
        <CardIncidentReport />
      </v-col>
    </v-row>
  </LayoutPage>
</template>

<script>
import { computed, onUnmounted } from "vue";
import LayoutPage from "@layout/LayoutPage.vue";
import CardIncidentInfo from "./CardIncidentInfo.vue";
import FormIncidentSurvey from "./FormIncidentSurvey.vue";
import CardIncidentReport from "./CardIncidentReport.vue";
import useIncident from "./useIncident";
import ButtonPrint from "@atoms/ButtonPrint.vue";
import CardIncidentTasks from "./CardIncidentTasks.vue";
import AddNewTask from "@components/manage_tasks/AddNewTask.vue";
import useAccess from "@components/authentication/useAccess";

export default {
  name: "PageIncident",
  components: {
    LayoutPage,
    CardIncidentInfo,
    FormIncidentSurvey,
    CardIncidentReport,
    CardIncidentTasks,
    ButtonPrint,
    AddNewTask,
  },
  setup() {
    const {
      incident,
      incidentTitle,
      loading,
      fetchIncident,
      cleanupIncidentRef,
    } = useIncident();
    const { showTaskManagement } = useAccess();

    const needsSurvey = computed(() => incident.value?.needsSurvey);
    const hasTasks = computed(() => (incident.value?.tasks?.length ?? 0) > 0);
    const surveyed = computed(() => incident.value?.surveyed);
    const defaultValue = computed(() => {
      return {
        unit:
          incidentTitle.value[1].split(" ")[0] +
          " - " +
          incident.value?.facilityName.split(" ")[0],
        taskType: "incident_resolution",
        incidentId: incident.value?.shortId,
      };
    });
    onUnmounted(cleanupIncidentRef);
    return {
      incidentTitle,
      loading,
      needsSurvey,
      hasTasks,
      surveyed,
      fetchIncident,
      defaultValue,
      showTaskManagement,
    };
  },
  computed: {
    incidentId() {
      return this.$route.params.incident_id;
    },
  },
  beforeMount() {
    this.fetchIncident(this.$apollo, this.incidentId);
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;

  li {
    list-style: none;
    padding: 0 0 0.35em 0;
  }
}
</style>
